import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const PreorderBannerWrapper = styled.div<{ $isSticky: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: ${getPurpurColor('functionalBlack')};
    padding: ${getPurpurSpacing('100')};
    color: ${getPurpurColor('functionalWhite')};
    font-weight: 700;
    font-size: ${({ $isSticky }) => ($isSticky ? '1rem' : '0.75rem')};

    &:last-child {
        padding: ${getPurpurSpacing('100')};
    }
`;
